const loginConfig = {
  allowLogin: true,
  allowSignUp: true,
  redirectUri: window.location.origin
};

export default loginConfig;
